import type { ShareRow } from '#shared/types';
import { api } from '#client/lib/api';
import { ENDPOINT } from '#client/lib/endpoints';

/**
 * Sends a visit's finalized reports to the patient on WhatsApp.
 *
 * A retry goes through here too: it *is* a new attempt — the server increments
 * `attempt_no` and links it back through `retry_of_id`, and the original row is
 * never touched. A resend must say so with `confirmResend`, or the server
 * refuses the repeat.
 */
export function sendShare(
  patientId: number,
  { reportIds, confirmResend }: { reportIds: readonly number[]; confirmResend: boolean },
): Promise<ShareRow> {
  return api.post<ShareRow>(ENDPOINT.patientShares(patientId), {
    report_ids: reportIds,
    confirm_resend: confirmResend,
  });
}
